module.exports = __webpack_public_path__ + "media/images/Carpentry Services Hero2-d63d4f40.webp";